module.exports = __webpack_public_path__ + "static/media/editFile.e0e90210.svg";